module.exports = __webpack_public_path__ + "images_/biz-micro-services-ui/packages/yofoui/customized/slider/asset/icon.png";


//////////////////
// WEBPACK FOOTER
// ../biz-micro-services-ui/packages/yofoui/customized/slider/asset/icon.png
// module id = 1055
// module chunks = 418